﻿//using System;
//using System.Collections;
//using System.Collections.Generic;
//using UnityEngine;

import {Time} from "../Utils/Unity/Time";

export class TimersManager {
    timeFromLastUpdate = 0; // float
    timeFromLastActionUpdate = 0; // float

    Init() {
        this.serverTimeUpdate(true);
    }

    serverTimeUpdate(force = false) {
        let deltaTime = Time.deltaTime;
        if (!Core.Time.Initialized) return;
        if (!Core.Player.Initialized) return;
        this.timeFromLastUpdate += deltaTime;
        if (force || this.timeFromLastUpdate > 1) {
            let currTicks = Core.Time.serverTime;
            for (let t of Core.Player.Timers.timers) {
                if (t.tStart == 0) {
                    t.InitializeStartTime(currTicks);
                } else if (!t.IsFinished) {
                    t.StepServerTime(currTicks);
                }
            }
            this.timeFromLastUpdate = 0;
        }
    }

    localTimeUpdate() {
        if (Core.Time.Initialized) return;
        for (let t of Core.Player.Timers.timers) {
            if (!t.IsFinished) t.Step(Time.deltaTime);
        }
    }

    Update() {
        if (!Core.Initialized) return;
        this.serverTimeUpdate();
        this.localTimeUpdate();
        this.updateMoneyBox();
    }

    updateMoneyBox() {
        if (Core.Time.Initialized) {
            let deltaTime = Time.deltaTime;
            this.timeFromLastActionUpdate += deltaTime;
            // Every 5 minutes
            if (this.timeFromLastActionUpdate > 300) {
                Core.Player.Timers.lastActionTime = Core.Time.serverTime;
                this.timeFromLastActionUpdate = 0;
            }
        }
    }

    Destroy() {

    }
}
